import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
    providedIn:'root'
})

export class availableLanguageService extends DatabaseGwService{
    URL_PATH: string = '/available_languages';
}